module.exports = __webpack_public_path__ + "img/percentage-sign.0153aaa1.png";